export interface IFilterTags {
    models: string;
}
